import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { AppDispatch } from "../store/store";

const MESSAGE_TIMEOUT_DURATION = 3000;

interface NotificationDescriptor {
  messageId?: string;
  message?: string;
  values?: Record<string, any>;
}

interface UiState {
  message: string;
  messageId: string | undefined;
  values: Record<string, any> | undefined;
  open: boolean;
}

const initialState: UiState = {
  message: "",
  messageId: undefined,
  values: undefined,
  open: false,
};

// @TODO: add different types of notifications (error, success, info, warning)
// @TODO: add a queue system to show multiple notifications in a row
const uiStateSlice = createSlice({
  name: "uiState",
  initialState,
  reducers: {
    openNotification: (
      state,
      action: PayloadAction<string | NotificationDescriptor>,
    ) => {
      const payload = action.payload;
      if (typeof payload === "string") {
        state.message = payload;
        state.messageId = undefined;
        state.values = undefined;
        state.open = true;
      } else if (
        payload &&
        typeof payload === "object" &&
        (payload.messageId || payload.message)
      ) {
        const { messageId, message, values } = payload;
        state.message = message || "";
        state.messageId = messageId;
        state.values = values;
        state.open = true;
      } else {
        state.open = true;
      }
    },
    closeNotification: (state) => {
      state.message = "";
      state.messageId = undefined;
      state.values = undefined;
      state.open = false;
    },
  },
});

export const { openNotification, closeNotification } = uiStateSlice.actions;

// Operations
export const showNotificationMessage = (
  messageOrDescriptor: string | NotificationDescriptor,
) => {
  return async (dispatch: AppDispatch) => {
    dispatch(openNotification(messageOrDescriptor));
    setTimeout(() => dispatch(closeNotification()), MESSAGE_TIMEOUT_DURATION);
  };
};

export const reducer = uiStateSlice.reducer;
